import React from 'react';
import { Target, Zap, Award, Heart } from 'lucide-react';
import { whyChooseATLREGEN } from '../data/mock';

const iconMap = {
  Target: Target,
  Zap: Zap,
  Award: Award,
  Heart: Heart
};

const WhyChooseUs = () => {
  return (
    <section id="why-choose" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block bg-[#20B2AA]/10 text-[#1B1B3A] px-5 py-2 rounded-full text-sm font-semibold mb-6">
              {whyChooseATLREGEN.overtitle}
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              {whyChooseATLREGEN.headline}
            </h2>
            <p className="text-xl text-gray-600 mb-10 leading-relaxed">
              {whyChooseATLREGEN.subheadline}
            </p>

            <div className="space-y-8">
              {whyChooseATLREGEN.reasons.map((reason, index) => {
                const IconComponent = iconMap[reason.icon];
                return (
                  <div key={index} className="flex gap-5">
                    <div className="flex-shrink-0">
                      <div className="bg-gradient-to-br from-[#E63946] to-[#D32F3D] p-4 rounded-xl shadow-lg">
                        <IconComponent className="h-7 w-7 text-white" />
                      </div>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        {reason.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed text-lg">
                        {reason.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="/webp-images/why-choose.webp"
                alt="Dr. Carroll D. Cooper at ATL Regen Atlanta"
                className="w-full h-[700px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1B1B3A]/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
